var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex flex-col flex-auto flex-shrink-0 antialiased bg-white dark:bg-gray-700 text-black dark:text-white"},[_c('Header',{attrs:{"isSidebarOpen":false}}),_c('div',{staticClass:"h-full p-9 ml-14 mt-14 mb-10"},[_c('child')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }